<template>
    <div class="how-to-page-off">
        <aside class="how-to-page-off__wrap">
            <nav class="how-to-page-off__menu">
                <ul class="how-to-page-off__menu-list">
                    <router-link class="how-to-page-off__menu-item"
                        v-for="item in repayMenu"
                        v-bind:class="item.className"
                        @click.native="scroll(item)"
                        :key="item.id"
                        :to="{ name: item.name , params: { repayName: item.name, repayText: item.text, repayImage: item.image}}">
                        <img class="how-to-page-off__item-icon" :src="item.image" alt="" />
                        <span class="how-to-page-off__item-description" v-html="item.text" @click.native="scroll(item)"></span>
                    </router-link>
                </ul>
            </nav>
        </aside>
        <div class="how-to-page-off__content">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </div>
    </div>
</template>

<script>
import widthMixin from "@/modules/mixins/widthMixin";

export default {
  name: "HowToPayOff",
  mixins: [widthMixin],
  data(){
    return {
      repayMenu: [
        {
            className: 'bank-card',
            name: 'RepayBankCard',
            image: require('@/assets/svg/icons/icon_1_mk.svg'),
            text: 'Банковской картой',
        },
        // {
	    //     className: 'cash-terminals',
        //     name: "RepayCashTerminals",
        //     image: require('@/assets/svg/icons/icon_2_mk.svg'),
        //     text: 'Наличными в терминалах',
        // },
        {
	        className: 'bank-transaction',
            name: 'RepayBankTransaction',
            image: require('@/assets/svg/icons/icon_3_mk.svg'),
            text: 'Банковским переводом',
        },
        {
	        className: 'electronic-wallets',
            name: 'RepayElectronicWallets',
            image: require('@/assets/svg/icons/icon_4_mk.svg'),
            text: 'С помощью электронных кошельков Qiwi и Касса24',
        },
      ]
    }
  },
  methods: {
  	scroll: function (item) {
        if(this.isMobile){
	        this.$scrollTo('.repay__'+item.className, {offset:-60});
        }
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.how-to-page-off {
    display: inline-flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: 1024px;
    width: 100%;
    margin: 0 auto;

    &__wrap {
        width: 100%;
        max-width: 240px;
        margin-bottom: 80px;
    }
    &__menu {
        width: 100%;
    }
    &__menu-list {

    }
    &__menu-item {
        position: relative;
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        min-height: 44px;
        list-style: none;
        text-decoration: none;

        &.router-link-active {
            background: $purple-site-o-2;
        }
    }
    &__menu-item:not(:last-child) {
        border-bottom: 1px solid $gray-mint;
    }
    &__item-icon {
        max-width: 32px;
        min-width: 32px;
        max-height: 28px;
        margin: 10px;
    }
    &__item-description {
        color: $gray-dim-dark;
        font-family: $RobotoRegular;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
    }
    &__content {
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: flex-start;
        box-sizing: border-box;
        max-width: 781px;
        width: 100%;
        padding: 0 0 80px 20px;
    }
}
@media screen and (max-width: 1024px) {
    .how-to-page-off {
        margin-top: 50px;
        &__wrap {
            max-width: unset;
            margin-bottom: 30px;
        }
        &__content {
            max-width: unset;
            padding: 0 15px 80px;
        }
        &__item-description {
            margin-right: 15px;
        }
    }
}
@media screen and (max-width: 768px) {

}
</style>
